import { connect } from 'react-redux'
import SchoolProfile from './school-profile'
import { getFetchSchoolRequest } from '../../../../stores/school/school.selectors'
import { fetchSchool } from '../../../../stores/school/school.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const fetchSchoolRequest = getFetchSchoolRequest(state)
  return {
    pending: fetchSchoolRequest.pending
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: () => dispatch(fetchSchool()).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SchoolProfile)
